
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/;

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,3}(?![^.\s])/;

export const nonDigitRegex = /[^0-9]/g;

export const phoneNumberRegex = /^\d{10}$/;

export const onlyAlphabet = /^[A-Za-z]+$/;

export const discountRegex = /^\d+$/;